import type { Node as PMNode } from "@tiptap/pm/model";
import {
  createProseMirrorMarkdownSerializer,
  MARKDOWN_SERIALIZER_PROFILES,
} from "../../../../src/shared/proseMirrorMarkdownSerializer";
import { plainTextToHtml } from "../../../../src/shared/markdownPasteUtils";
import { renderMarkdownForTiptapInsert } from "src/lib/renderMarkdownForTiptap";

const instructionsMarkdownSerializer = createProseMirrorMarkdownSerializer(MARKDOWN_SERIALIZER_PROFILES.CLIPBOARD);

export const STYLE_INSTRUCTIONS_PLACEHOLDER =
  "Describe how you want your prose to sound when this style is selected.";

export function instructionsMarkdownToHtml(markdown: string): string {
  const source = String(markdown ?? "");
  if (!source.trim()) return "<p></p>";
  return renderMarkdownForTiptapInsert(source) ?? plainTextToHtml(source);
}

export function serializeInstructionsDoc(doc: PMNode): string {
  return instructionsMarkdownSerializer.serialize(doc).replace(/\u00a0/g, " ").trim();
}
